/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { BlockDetailsCard, BlockInformation, Header } from "../../components";
import { useAppProviderContext } from "../../context/appProvider";
import { prepareModalPopupInfo } from "../../helpers";
import { useIBModalPopup } from "../../hooks";
import { IModalData, IOtherFlexCard } from "../../interfaces";

const OtherFlexCard: React.FC<IOtherFlexCard> = (props: IOtherFlexCard) => {
  const { headerInfo, cardInfo, blockInfo } = props;
  const { actions, state } = useAppProviderContext();

  const [isPrimaryButtonClicked, setIsPrimaryButtonClicked] = useState(false);
  const { showModalPopup } = useIBModalPopup(setIsPrimaryButtonClicked);

  const isDeclineAllState =
    cardInfo?.isDeclineAll && !cardInfo?.impulseDelayRemaining;

  const handleBlockChange = () => {
    const popupInfo: IModalData = prepareModalPopupInfo(
      state,
      isDeclineAllState
    );
    showModalPopup(popupInfo);
  };

  useEffect(() => {
    if (isPrimaryButtonClicked) {
      void actions.setGamblingControl(
        state.startupData?.account[0]?.tokenisedPan as string,
        !isDeclineAllState
      );
    }
  }, [isPrimaryButtonClicked]);

  return (
    <>
      <Header {...headerInfo} />
      <BlockDetailsCard
        {...cardInfo}
        handleBlockStatusChange={handleBlockChange}
      />
      <BlockInformation
        showGamCareLink={
          cardInfo.isDeclineAll && !cardInfo.impulseDelayRemaining
        }
        {...blockInfo}
      />
    </>
  );
};

export default OtherFlexCard;
